<template>
  <div id="workspace">
    <input v-model="bet" @keypress="isNumber($event)">
    <div class="btn_ctrl" @click="addBet()">Add bet</div>
  </div>
</template>

<script>
import {inject, provide} from "vue";
import GameService from '../../services/game.service';
import cashier from "@/services/cashier.service";

export default {
  name: "Lotto100",
  data () {
    return {
      bet: '',
      selected: [],
      cur_split_selected: []
    }
  },
  setup()
  {
    const game_kind = inject('gameKind')
    const game_alias = inject('gameAlias')
    const extra_bet = inject('gameExtra')
    const gameId = inject('gameId');
    return {
      game_kind,
      game_alias,
      extra_bet,
      gameId
    }
  },
  props: ['event', 'public_event', 'bet_value'],
  methods: {
    addBet()
    {
      let bet = this.bet;

      if(bet.length !== 2)
      {
        return;
      }

      let bv = 'lotto100_'+bet;

      let found = '';

      for (let sel of this.selected)
      {
        if (sel.bet === bv)
        {
          found = sel;
        }
      }

      if (found !== '')
      {
        return;
      }

      this.selected.push({
        bet: bv,
        event: this.event,
        public_event: this.public_event,
        bet_value: this.bet_value,
        multiplier: 80,
        bet_name: bv,
        ntt: 'n'
      });

      this.$emit('getBet', this.selected);

      this.cur_split_selected = [];
      this.bet = '';
    },
    clear_bet()
    {
      this.selected = [];
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;

      let disablePoint = true;

      let cur_value = this.bet;

      if(cur_value.length > 1)
      {
        evt.preventDefault();
      }


      if (((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 && !disablePoint || disablePoint))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addBetEvent(event)
    {
      if (event.keyCode == 32)
      {
        event.preventDefault();
        this.addBet();
      }
    }
  },
  mounted() {
    window.addEventListener('keyup', this.addBetEvent)
  }
}
</script>

<style scoped>

  #workspace
  {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: cornflowerblue;
  }
  #game_bets
  {
    width: 100%;
    display: grid;
    grid-template-rows: 11% 11% 11% 11% 11% 11%;
  }
  .bet_area
  {
    height: 98%;
    width: 95%;
    display: grid;
    grid-template-rows: 85% 15%;
  }
  .controls_cont
  {
    display: grid;
    grid-template-rows: 50% 50%;
  }
  .bet_cell
  {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #DDDDDD;
    margin: 2px;
    cursor:pointer;
    font-size: 100%;
    font-weight: bold;
    background-color: darkgreen;
  }
  .selected
  {
    box-shadow: inset 0px 0px 0px 5px #53ea93;
    box-sizing: border-box;
    background-color: darkorchid;
    color: white;
  }
  .selected_shatters
  {
    background-color: darkkhaki;
    color: white;
  }
  .bet_line
  {
    width: 100%;
    display: grid;
    grid-template-columns: 26% 8% 8% 8% 8% 8% 8% 26%;
  }
  .bisque
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 30px;
    cursor: pointer;
  }
  .randoms
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .control_buttons
  {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn_ctrl
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 120px;
    cursor: pointer;
  }
  .btn_risk
  {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
    color: black;
    margin: 5px;
    height: 30px;
    width: 120px;
    cursor: pointer;
  }
  .risk_selected
  {
    background-color: #8c918d;
  }
  .mb div
  {
    width: 8px;
    height: 8px;
    margin-left: 2px;
    background-color: darkgreen;
  }
  .mb
  {
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid;
    border-radius: 5px;
    background-color: darkgray;
    cursor: pointer;
  }
  .hb
  {
    height: 30px;
    margin-left: 5px;
  }
  .vb
  {
    margin-top: 5px;
    width: 30px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
  }
  .vb div
  {
    margin-top: 2px;
  }
  .mbx
  {
    height: 30px;
    width: 30px;
    background-color: white;
    margin-left: 5px;
  }
  .selected_b
  {
    background-color: white;
  }
  .extras>div
  {
    display: flex;
    flex-direction: row;
    width: 50%;
  }
</style>